import React, {Component} from 'react'

class EducationBox extends Component {
  render() {
    return (
      <div className="col-md-6 widget">
        <div className="title">Education</div>
        <div className="row">
          <div className="col"> 
            <div className="row">
              <div className="col-4">Schools:</div>
              <div className="col-8">{this.props.schools}</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default EducationBox